/* eslint no-nested-ternary: 0 */
import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Search url VO
 * In the future it will represent more urls than just tag.
 */
export default class NewsSearchUrlValueObject extends ValueObject {
  /**
   * @constructor
   */
  constructor({config, tag, category, searchTerm, section, page, removeAccents}) {
    super()
    this._config = config
    this._section = section
    this._tag = tag
    this._searchTerm = searchTerm
    this._categoriesMapping = config.get('editorial').newsCategories
    this._mappedCategory = this._mapCategory(tag)
    this._category = category || this._mappedCategory || ''
    this._page = page
    this._searchUrlPattern = config.get('page').NEWS_SEARCH_PATH_PATTERN
    this._tagUrlPattern = config.get('page').NEWS_TAG_PATH_PATTERN
    this._categoryUrlPattern = config.get('page').NEWS_CATEGORY_PATH_PATTERN
    this._homeUrlPattern = config.get('page').NEWS_HOME_PATH_PATTERN
    this._paramsPattern = config.get('page').PARAMS_PATTERN
    this._querySearchPattern = config.get('page').QUERY_SEARCH_PATTERN
    this._paginationPattern = config.get('page').PAGINATION_PATTERN
    this._querySearchRegex = new RegExp(`${this._paramsPattern}${this._querySearchPattern}`, 'g')
    this._removeAccents = removeAccents
  }

  _getNewsPathPattern(params) {
    const {NEWS_HOME_PATH_PATTERN, NEWS_CATEGORY_PATH_PATTERN, NEWS_TAG_PATH_PATTERN, NEWS_SEARCH_PATH_PATTERN} =
      this._config.get('page')

    const [newsType] = Object.keys(params)

    switch (newsType) {
      case 'category':
        return NEWS_CATEGORY_PATH_PATTERN
      case 'tag':
        return NEWS_TAG_PATH_PATTERN
      case 'search':
        return NEWS_SEARCH_PATH_PATTERN
      case 'section':
        return this._getSectionPathPattern({section: params.section})
      default:
        return NEWS_HOME_PATH_PATTERN
    }
  }

  _getSectionPathPattern = ({section}) => {
    const {TIPS, TRENDS} = this._config.get('COMMON').NEWS_SECTIONS
    const {NEWS_SECTION_TIPS_PATH_PATTERN, NEWS_SECTION_TRENDS_PATH_PATTERN} = this._config.get('page')

    switch (section) {
      case TIPS:
        return NEWS_SECTION_TIPS_PATH_PATTERN
      case TRENDS:
        return NEWS_SECTION_TRENDS_PATH_PATTERN
    }
  }

  _mapCategory = tag => {
    const mappedCategory = this._categoriesMapping.find(({label}) => label === tag)
    return mappedCategory?.label
  }

  _setParamToPage = url => (this._querySearchRegex.test(url) ? '&' : '?')

  _addPagination(url) {
    const paramForUrl = this._setParamToPage(url)
    return this._page && this._page !== 1 ? `${url}${paramForUrl}${this._paginationPattern}${this._page}` : url
  }

  /*
   * @return {String}
   * if exists searchTerm construct url w/ buildSearchUrl pattern
   * if not, checks if exists a tag and is not a category and construct url w/ buildTag pattern,
   * finally if neither passed, is a category and construct url w/ category pattern
   */

  _buildUrl() {
    const onlyHasSearchTerm = !this._category && !this._tag && this._searchTerm
    const hasTagAndUnmappedCategory = this._tag && !this._mappedCategory
    const newsParams = {
      ...(this._category && {category: this._category}),
      ...(this._searchTerm && {term: this._searchTerm}),
      ...(this._tag && {tag: this._tag}),
      ...(this._section && {section: this._section})
    }
    if (onlyHasSearchTerm) {
      return this._addPagination(this._buildSearchUrl())
    } else {
      if (hasTagAndUnmappedCategory) {
        return this._addPagination(this._buildTagUrl())
      } else {
        return this._addPagination(this._buildCategoryUrl(this._getNewsPathPattern({...newsParams})))
      }
    }
  }

  _buildTagUrl() {
    return this._tagUrlPattern.replace(':tag', this._removeAccents(this._tag.replace(/ /g, '-')))
  }

  _buildCategoryUrl(urlPattern) {
    return urlPattern.replace(':category', this._category.replace(/ /g, '-'))
  }

  _buildSearchUrl() {
    return this._searchUrlPattern.replace(':tag', this._removeAccents(this._searchTerm.replace(/ /g, '-')))
  }

  toString() {
    return this._buildUrl()
  }

  toJSON() {
    return this.toString()
  }
}
